import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import { Icon } from 'leaflet';
import vuetify from './plugins/vuetify'
import 'leaflet/dist/leaflet.css';
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.prototype.$user = {
  "gender":"female",
  "name":{"title":"Ms","first":"Julia","last":"Poppe"},
  "location":{"street":{"number":3595,"name":"Mühlenstraße"},"city":"Hörstel","state":"Niedersachsen","country":"Germany","postcode":95655,"coordinates":{"latitude":"-46.8693","longitude":"18.2419"},"timezone":{"offset":"-2:00","description":"Mid-Atlantic"}},
  "email":"julia.poppe@example.com",
  "login":{"uuid":"8af65a68-f2e6-41a1-9695-edb39aac06eb","username":"goldenswan876","password":"morgan1","salt":"l6AhPeKA","md5":"19e25f6da5ecbf36923aac5dc7802ef3","sha1":"49f1a4223049b9705bbf5ac2ef3c58d549e91d08","sha256":"9bdf4f459bbda13804e98435a8fd94e0225f5fa18dbdebca24da285665dcae12"},
  "dob":{"date":"1983-02-16T20:59:33.855Z","age":38},
  "registered":{"date":"2005-11-16T20:34:25.260Z","age":16},
  "phone":"0667-0487959",
  "cell":"0179-0547397",
  "id":{"name":"","value":null},
  "picture":{"large":"https://randomuser.me/api/portraits/women/58.jpg","medium":"https://randomuser.me/api/portraits/med/women/58.jpg","thumbnail":"https://randomuser.me/api/portraits/thumb/women/58.jpg"},
  "nat":"DE",
  joinedEvents:[],
  availableCoupons: [
    /*{
      id:0,
      color:"white",
      title:"Test coupon!",
      amount: "$15",
      src: require('./assets/discount-pictures/0.jpg'),
      rating:4.5,
    }*/
  ],
};


// Vue object creation
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

// Leaflet icon correction
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
